import { useQuery } from "@tanstack/react-query";
import { GraphData, graphService } from "../../services/graphService";
import { queryKeys } from "./keys";

interface GraphOptions {
  orgStructure?: string;
  supplierTiers?: number;
  customerTiers?: number;
  homeCountry?: string[];
  organizationTypes?: string[];
  naics?: string[];
  inputHsCodes?: string[];
  outputHsCodes?: string[];
  foundingYearMin?: number;
  foundingYearMax?: number;
  labels?: string[];
  relationshipFilters?: any[];
}

/**
 * TanStack Query hook for fetching graph visualization data.
 *
 * The caller controls when fetches happen by passing **committed** values
 * (entityId / options) that only change on explicit user action (e.g.
 * "Update Graph" button).  The query auto-fetches whenever the committed
 * key changes, and cached results are served instantly for previously-
 * fetched keys.
 */
export function useGraphData(
  entityId: string | undefined,
  options: GraphOptions,
) {
  return useQuery<GraphData>({
    queryKey: queryKeys.graph.data(
      entityId ?? "",
      options as Record<string, unknown>,
    ),
    queryFn: () => graphService.getGraphData(entityId!, options),
    enabled: !!entityId,
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
}
